import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { MyorderModel } from '@/module/MyOrder/model/MyorderModel.js';

/**
 * @method apiGetOrderFavorite
 */
export default {
    apiGetOrderFavorite: function() {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/order';
        let params = {
            favourite: true,
            top: 0,
        }
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            var arrMyorder = [];
            for (var i of res.data) {
                var objMyorder = new MyorderModel(i);
                arrMyorder.push(objMyorder);
            }

            return arrMyorder;
        }));
    },
}
